document.addEventListener("DOMContentLoaded", function () {

  function initSwiper(selector, options) {
    const el = document.querySelector(selector);
    if (!el) return null;
    return new Swiper(el, options);
  }
    initSwiper(".pictureSwiper", {
    loop: true,
    pagination: {
      el: '.swiper-pagination',
    }
  });  

    initSwiper(".blog_swiper", {
   slidesPerView : 'auto',  
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: true,
      },
  });  
  // ===== Home Product Swiper =====
  initSwiper(".swiper_product", {
    slidesPerView :'auto',
    mousewheel: { forceToAxis: true },
    keyboard: { enabled: true, onlyInViewport: true },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    scrollbar: { el: ".swiper-scrollbar", draggable: true },
  });

  // ===== Blend Swiper + Tabs =====
  const tabEls = document.querySelectorAll(".js-feature-tabs .feature-tab__item");
  const blendSwiper = initSwiper(".js-blend-swiper", {
    loop: false,
    scrollbar: { el: ".swiper-scrollbar", draggable: true },
    effect: window.innerWidth < 768 ? "slide" : "fade",
    breakpoints: {
      320: { slidesPerView: 1.1, spaceBetween: 16 },
      768: { slidesPerView: 1 }
    },
    on: {
      slideChange: () => {
        const index = blendSwiper.realIndex;
        tabEls.forEach((el, i) => el.classList.toggle("active", i === index));
      }
    }
  });

  // Tab 
  tabEls.forEach((el, index) => {
    el.addEventListener("click", () => {
      if (!blendSwiper) return;
      blendSwiper.slideTo(index);
      tabEls.forEach((t, i) => t.classList.toggle("active", i === index));
    });
  });

  // ===== Features Swiper =====
  initSwiper(".features_swiper", {
    slidesPerView: 4,
    spaceBetween: 35,
    mousewheel: { forceToAxis: true },
    keyboard: { enabled: true, onlyInViewport: true },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    scrollbar: { el: ".swiper-scrollbar", draggable: true },
    breakpoints: {
      320: { slidesPerView: 1.3, spaceBetween: 16 },
      768: { slidesPerView: 3.2, spaceBetween: 32 },
      1280: { slidesPerView: 3.7, spaceBetween: 35 }
    }
  });

});
